import React from 'react';

const Footer = () => {
    const scrollToSection = (sectionId) => {
        if (sectionId === 'services') {
            // Services is part of the animated scroll sequence
            // According to App.js transforms:
            // - Services slides into view at 15-20% of scroll progress
            // - Total scroll container height is 557vh (desktop), 620vh (medium), 700vh (mobile)
            // We want to scroll to 20% to show Services when card animations start

            // Get viewport height and determine scroll container height
            const viewportHeight = window.innerHeight;
            const width = window.innerWidth;
            let scrollContainerHeight;

            if (width < 640) { // mobile
                scrollContainerHeight = viewportHeight * 7; // 700vh
            } else if (width < 768) { // medium
                scrollContainerHeight = viewportHeight * 6.2; // 620vh
            } else { // desktop
                scrollContainerHeight = viewportHeight * 5.57; // 557vh
            }

            // Calculate 30% of the scroll container height
            // This ensures we're well into the Services section with card animations visible
            const targetScroll = scrollContainerHeight * 0.30;
            window.scrollTo({ top: targetScroll, behavior: 'smooth' });
        } else if (sectionId === 'hero') {
            // Hero is at the top
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            // For other sections, use normal scrollIntoView
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    return (
        <footer className="bg-[#e3daed] py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
                    {/* Contact Section */}
                    <div>
                        <h3 className="font-nunito font-semibold text-sm tracking-wider mb-4">CONTACT</h3>
                        <div className="space-y-2 text-sm">
                            <p className="font-nunito font-light">Ashima Goel</p>
                            <a
                                href="https://mail.google.com/mail/?view=cm&fs=1&to=ashimagoeltherapy@gmail.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="font-nunito font-light hover:underline block"
                            >
                                ashimagoeltherapy@gmail.com
                            </a>
                            <p className="font-nunito font-light">Delhi, India</p>
                        </div>

                        {/* Social Icons */}
                        <div className="flex gap-4 mt-6">
                            {/* Instagram */}
                            <a
                                href="https://www.instagram.com/ktia__therapy?igsh=MWcxNXh3cDMwM3J2dg=="
                                target="_blank"f
                                rel="noopener noreferrer"
                                className="hover:opacity-70 transition-opacity"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z" />
                                </svg>
                            </a>

                            {/* Facebook */}
                            <a
                                href="https://facebook.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                 className="hover:opacity-70 transition-opacity"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /> 
                                </svg>
                            </a>

                            {/* Twitter/X */}
                            <a
                                href="https://twitter.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:opacity-70 transition-opacity"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                                </svg>
                            </a>

                            {/* TikTok */}
                            <a
                                href="https://tiktok.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:opacity-70 transition-opacity"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Menu Section */}
                    <div>
                        <h3 className="font-nunito font-semibold text-sm tracking-wider mb-4">MENU</h3>
                        <ul className="space-y-2">
                            <li>
                                <button
                                    onClick={() => scrollToSection('hero')}
                                    className="font-nunito text-sm hover:underline text-left"
                                >
                                    Home
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => scrollToSection('about')}
                                    className="font-nunito text-sm hover:underline text-left"
                                >
                                    About
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => scrollToSection('services')}
                                    className="font-nunito text-sm hover:underline text-left"
                                >
                                    Services
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => scrollToSection('booking')}
                                    className="font-nunito text-sm hover:underline text-left"
                                >
                                    Book Now
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Legal Section */}
                    <div>
                        <h3 className="font-nunito font-semibold text-sm tracking-wider mb-4">LEGAL</h3>
                        <ul className="space-y-2">
                            <li>
                                <a
                                    href="/privacy-policy"
                                    className="font-nunito text-sm hover:underline"
                                >
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/terms-of-service"
                                    className="font-nunito text-sm hover:underline"
                                >
                                    Terms of Service
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Copyright */}
                <div className="mt-12 pt-8 border-t border-gray-300">
                    <p className="text-center text-xs font-nunito font-light text-gray-600">
                        © 2025 KTIA Foundation - Ashima Goel. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 